
import React, { Component, Fragment } from 'react';
import { ReactComponent as BiddingDetailsIcon } from 'Icons/bidding.svg';
import { ReactComponent as UploadIcon } from 'Icons/upload-new.svg';
import { ReactComponent as DeleteIcon } from 'Icons/delete.svg';
import Select from 'react-select';
import Checkbox from 'Components/Checkbox/index';
import { DateRangePicker, SingleDatePicker } from 'react-dates';
import TimePicker from 'rc-time-picker';
import { FileUploader } from "react-drag-drop-files";
import Moment from 'moment';
import {
    PAYMENT_TERMS_LIST
} from 'Constants/commonConstants';
import Classnames from 'classnames';
import {v4 as uuidv4} from 'uuid';

const TRIP_TYPE = "trip";
class BiddingDetails extends Component {
    constructor(props) {
        super(props);
        const biddingDetails = props.biddingDetails;
        this.viewMode = props.viewMode;
        this.viewType = props.viewType;
        this.biddingDetails = biddingDetails;
        this.rfqDetails = props.rfqDetails;
        this.state = {
            biddingDetails,
            isMissingUOM: false,
            businessVolumes: this.props.businessVolumes,
            isConfirmation: false,
            acceptPartialSolution: props.rfqDetails.acceptPartialSolution,
            contractNote: props.rfqDetails.contractNote ? props.rfqDetails.contractNote : '',
            rfqLevelSeekerRemarks: props.rfqDetails.rfqLevelSeekerRemarks || ''
        }
    }

    checkIsOutside = (date, rfqServiceType) => {
        const { systemTime } = this.props;
        if(rfqServiceType === 4)
            return !Moment(date).isBetween(Moment(new Date(systemTime)).subtract(1,'days'), Moment(new Date(systemTime)).add(6, 'days'));
        else 
            return date < new Date(systemTime).setHours(0);
    }

    onSelect = (value, name)=> {
        if(this.viewMode || (this.viewType === TRIP_TYPE && (name==="paymentCycle" || name==="pricingBasis"))) {
            return;
        }
        this.biddingDetails['set' + name.substr(0,1).toUpperCase() + name.slice(1) ](value);
        this.setState({
            biddingDetails: this.biddingDetails
        })
        this.props.onChange()

    }

    setAcceptPartialSolution = (acceptPartialSolution)=> {
        if(this.viewMode) {
            return;
        }
        this.setState({
            acceptPartialSolution
        });
        this.rfqDetails.setAcceptPartialSolution(acceptPartialSolution);
    } 

    changePaymentTerms = (option)=> {
        if(this.viewMode || this.viewType === TRIP_TYPE) {
            return;
        }
        this.biddingDetails.setPaymentTerms(option.vale, null, option.name);
        this.setState({
            biddingDetails: this.biddingDetails
        })
        this.props.onChange()
    }

    handleContractNotes = (e) => {
        if (this.props.rfqDetails) {
			  this.setState({ contractNote: e.target.value });
			  this.props.rfqDetails.setContractNote(e.target.value);
        }
    }

    handleSeekerRemarks = (e) => {
        if (this.props.rfqDetails) {
			  this.setState({ rfqLevelSeekerRemarks: e.target.value });
			  this.props.rfqDetails.setRfqLevelSeekerRemarks(e.target.value);
        }
    }

    onChange= (file)=> {
        this.props.uploadDocument(file[0]);
    }

    render() {
        const { 
            systemTime, 
            rfqServiceType,
            pricingBasis,
            paymentCycles,
            documents,
            removeDocument,
            submitted
        } = this.props;
        const {
            biddingDetails
        } = this.state;
        return (
            <div className='biddingDetails ph-30 pv-30 mt-10'>
                <div className='header flex'>
                    <BiddingDetailsIcon />
                    <div className='ml-10'>Bidding Details</div>
                </div>
                <div className='pt-20 subHeader'>Bidding Info</div>
                <div className='flex pt-20'>
                    <div className='col-2 mr-15'>
                        <div className='rfqlabel'>Pricing Basis <sup className='error-color fs-14'>*</sup>
                            {submitted && !(biddingDetails.pricingBasis) && <span className="error-color fs-14 fSemibold op-7 ml-5">Please Select The Field</span>}
                        </div>
                        <Select 
                            options={pricingBasis}
                            getOptionLabel={option => option.name}
                            onChange={(option) => this.onSelect(option, 'pricingBasis')}
                            value={pricingBasis.find(pricingBasis=>{return biddingDetails.pricingBasis === pricingBasis.value})} 
                        />
                    </div>
                    <div className='col-2 ml-15'>
                        <div className='rfqlabel'>Bidding Solution</div>
                        <div className="flex mb-10 mt-10">
                            <Checkbox label="Partial Solution" checked={this.state.acceptPartialSolution} className="mr-30" onCheck={this.setAcceptPartialSolution.bind(this, true)}/>
                            <Checkbox label="Complete Solution" checked={!this.state.acceptPartialSolution} onCheck={this.setAcceptPartialSolution.bind(this, false)}/>
                        </div>
                    </div>
                </div>
                <div>
                    <div  className='flex pt-20'> 
                        <div className='col-2 mr-15 tStart'>
                            <div className='rfqlabel'>Bidding From <sup className='error-color fs-14'>*</sup></div>
                            <SingleDatePicker
                                        noBorder={true}
                                        displayFormat={"DD MMM YYYY"}
                                        hideKeyboardShortcutsPanel={true}
                                        placeholder={"Placement Date"}
                                        numberOfMonths={2}
                                        date={Moment(this.biddingDetails.from)} 
                                        onDateChange={(from) =>{
                                            if(this.viewMode || this.viewType === TRIP_TYPE) {
                                                return;
                                            }
                                            const date = from.format('YYYY-MM-DD') + ' ' + Moment(this.biddingDetails.from).format('HH:mm')
                                            this.biddingDetails.setFrom(new Date(date).getTime());
                                            if(bidEndTimeValue > 0) {
                                                this.biddingDetails.setTo(new Date(date).getTime() + bidEndTimeValue);
                                            }
                                            this.setState({ biddingDetails: this.biddingDetails });
                                            this.props.onChange()
                                        }}
                                        focused={this.state.focusedStart} 
                                        onFocusChange={({ focused }) => this.setState({ focusedStart: (this.viewMode || this.viewType === TRIP_TYPE)?null:focused })} 
                                        isOutsideRange={(date) => date < new Date(systemTime).setHours(0)}
                                        // isOutsideRange={(date) => date < Moment(systemTime).setHours(0)}
                                    />
                                    <TimePicker
                                        showSecond={false}
                                        value={Moment(this.biddingDetails.from)}
                                        className="ht-40 wt-150 border-status-bar br-5"
                                        onChange={(from) =>{
                                            if(this.viewMode || this.viewType === TRIP_TYPE) {
                                                return;
                                            }
                                            const date = Moment(this.biddingDetails.from).format('YYYY-MM-DD') + ' ' + from.format('HH:mm')
                                            this.biddingDetails.setFrom(new Date(date).getTime());
                                            if(bidEndTimeValue > 0) {
                                                this.biddingDetails.setTo(new Date(date).getTime() + bidEndTimeValue);
                                            }
                                            this.setState({ biddingDetails: this.biddingDetails });
                                            this.props.onChange()
                                        }}
                                        // minTime={new Date()}
                                        minTime={Moment(systemTime)}
                                        format={'h:mm a'}
                                        use12Hours
                                        inputReadOnly
                                        disabled={this.viewMode || this.viewType===TRIP_TYPE}
                                    />
                        </div>
                        <div className='col-2 ml-15 tStart'>
                            <div className='rfqlabel'>Bidding To <sup className='error-color fs-14'>*</sup></div>
                            <SingleDatePicker
                                        noBorder={true}
                                        displayFormat={"DD MMM YYYY"}
                                        hideKeyboardShortcutsPanel={true}
                                        placeholder={"Please Add Bidding To"}
                                        numberOfMonths={2}
                                        date={this.biddingDetails.to?Moment(this.biddingDetails.to):null} 
                                        onDateChange={(from) =>{
                                            if(this.viewMode || this.viewType === TRIP_TYPE) {
                                                return;
                                            }
                                            // const date = from.format('YYYY-MM-DD') + ' ' + Moment(this.biddingDetails.to?this.biddingDetails.to:new Date().getTime()).format('HH:mm')
                                            const date = from.format('YYYY-MM-DD') + ' ' + Moment(this.biddingDetails.to?this.biddingDetails.to: systemTime).format('HH:mm')
                                            this.biddingDetails.setTo(new Date(date).getTime());
                                            this.setState({ biddingDetails: this.biddingDetails });
                                            this.props.onChange()
                                        }}
                                        focused={this.state.focusedEnd} 
                                        onFocusChange={({ focused }) => this.setState({ focusedEnd: (this.viewMode || this.viewType === TRIP_TYPE)?null:focused })}
                                        isOutsideRange={(date) => this.checkIsOutside(date, rfqServiceType)}
                                    />
                                    <TimePicker
                                        showSecond={false}
                                        value={this.biddingDetails.to?Moment(this.biddingDetails.to): null}
                                        className="ht-40 wt-150 border-status-bar br-5"
                                        onChange={(to) =>{
                                            if(this.viewMode || this.viewType === TRIP_TYPE || !this.biddingDetails.to) {
                                                return;
                                            }
                                            const date = Moment(this.biddingDetails.to).format('YYYY-MM-DD') + ' ' + to.format('HH:mm')
                                            this.biddingDetails.setTo(new Date(date).getTime());
                                            this.setState({ biddingDetails: this.biddingDetails });
                                            this.props.onChange()
                                        }}
                                        // minTime={new Date()}
                                        minTime={Moment(systemTime)}
                                        format={'h:mm a'}
                                        use12Hours
                                        inputReadOnly
                                        disabled={this.viewMode || !this.biddingDetails.to || this.viewType===TRIP_TYPE}
                                    />
                                {submitted && !(this.state.biddingDetails.to) && <span className="error-color fs-14 fSemibold op-7 ml-5">Please Select Bidding Time</span>}
                        </div>
                    </div>
                </div>
                <div className='pt-20 subHeader'>Payment Info</div>
                <div className='flex mt-10'>
                    <div className='col-2 mr-15'>
                        <div className='rfqlabel'>Payment Terms</div>
                        <Select
                            options={PAYMENT_TERMS_LIST} 
                            onChange={this.changePaymentTerms}
                            value={PAYMENT_TERMS_LIST.find(el => biddingDetails.paymentTerms === el.value) }
                        />
                    </div>
                    <div className='col-2 ml-15'>
                        <div className='rfqlabel'>Payment Cycle</div>
                        <Select 
                            options={paymentCycles} 
                            value={paymentCycles.find(paymentCycle=>{return biddingDetails.paymentCycle === paymentCycle.value})}
                            getOptionLabel={option => option.name}
                            onChange={(option) => this.onSelect(option, 'paymentCycle')}
                        />
                    </div>
                </div>
                <div className='pt-20 subHeader'>Other Info</div>
                <div className='pt-10'>
                    <div className='rfqlabel'>Terms & Conditions and Other Documents <sup className='error-color fs-14'>*</sup> 
                    {(submitted && !(documents|| []).length) && <span className="error-color fs-14 fSemibold op-7 ml-5">Please Upload Atleast One Document</span>}
                    </div>
                    <div className='uploadBorder'>
                        <FileUploader
                            multiple={true}
                            handleChange={this.onChange}
                            name="file"
                        >
                            <div className='tCenter mt-20 mb-20'>
                                <UploadIcon />
                                <div className="uploadText">Drop Items Here</div>
                                <div className='orValue mt-10'>Or</div>
                                <div className='tCenter mt-20'>
                                    <span className='browseButton'>Browse Files</span>
                                </div>
                            </div>
                        </FileUploader>
                    </div>
                    <div className={Classnames("flex flex-wrap", {
                        "flex-between": (documents || []).length > 2,
                        "flex-around": (documents || []).length <= 2
                    })}>
                        {
                            documents.map((document, index)=> {
                                return (
                                    <div>
                                        <a key={uuidv4()} className="wt-150 mr-20 curP mb-40"  href={document.url} >
                                            <span className="fSemibold fs-16 header-medium-color">{document.name}</span>
                                        </a>
                                        <DeleteIcon className='wt-20 ht-20' onClick={() => removeDocument(index)}/>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <div className='pt-20'>
                    <div className='rfqlabel'>Contract Note</div>
                    <textarea 
                        className='cargoInput col-1 p-10'  
                        cols={4}  
                        placeholder='Enter Contract Notes...'
                        name="Contract Notes"
                        value={this.state.contractNote}
                        onChange={this.handleContractNotes}
                        readOnly={this.viewMode}
                    />
                </div>

                <div className='pt-20'>
                    <div className='rfqlabel'>Remarks</div>
                    <textarea 
                        className='cargoInput col-1 p-10'  
                        cols={4}  
                        placeholder='Enter Remarks...'
                        name="Remarks"
                        value={this.state.rfqLevelSeekerRemarks}
                        onChange={this.handleSeekerRemarks}
                    />
                </div>
            </div>
        )
    }
}

export default BiddingDetails;